import { Menu } from "lucide-react";
import { Button } from "../ui/button/index.js";
import { cn } from "../../lib/utils.js";

export const WORKSPACE_DRAWER_TRIGGER_CLASS = "max-w-[16rem] shrink-0 gap-2 border-line/70";

export function WorkspaceDrawerTrigger({
  label,
  open,
  onClick,
  testId,
  ariaLabel,
}: {
  label: string;
  open: boolean;
  onClick: () => void;
  testId?: string;
  ariaLabel: string;
}): React.JSX.Element {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={WORKSPACE_DRAWER_TRIGGER_CLASS}
      onClick={onClick}
      aria-expanded={open}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      <span className="min-w-0 truncate">{label}</span>
      <Menu
        size={16}
        className={cn(
          "shrink-0 text-muted transition-transform duration-200 motion-reduce:transition-none rtl:order-first",
          open && "rotate-90 text-accent",
        )}
        aria-hidden="true"
      />
    </Button>
  );
}
